import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebPushNotificationService extends ApiAuthService {

  private notificationsSubject = new BehaviorSubject<number>(0);
  notifications$ = this.notificationsSubject.asObservable();

  updateNotificationCount(count: number) {
    this.notificationsSubject.next(count);
  }

  private readonly url = `${this.baseUrl}/web-push-notification`;
  async saveSubscription(subscriptionObj: any): Promise<any> {
    let body = subscriptionObj;
    return this.request(() => this.http.post(`${this.url}/save-subscription`, body).toPromise());
  }

  async removeSubscription(userId: string, endPoint: string): Promise<any> {
      return this.request(() => this.http.delete(`${this.url}`, {
          params: {
            userId: userId,
            endPoint: endPoint
          }
      }).toPromise());
  }

  async getNotifications() {
    return this.request(() => this.http.get(`${this.url}/history`).toPromise());
  }

  async getAllNotifications(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<any> {
    let params = {};    
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get(`${this.url}/history`, { params: params }).toPromise());
  }

  async getNotificationCount(userId: number): Promise<{count: number}> {
    return this.request(() => this.http.get(`${this.url}/count/${userId}`).toPromise());
  }

  async markAsRead(ids: string, userId: number) {
    return this.request(() => this.http.post(`${this.url}/mark-as-read/${userId}`, {
      ids: ids
    }).toPromise());
  }

  async removeNotificationHistory(id: number): Promise<boolean> {
    return this.request(() => this.http.delete(`${this.url}/${id}`).toPromise());
  }
}
